import { windowExists } from "$routes/_lib/globals";

function getLocationUrl() {
  const windowRef = windowExists;

  if (!windowRef.location) {
    return "";
  }

  const {
    location: { protocol, origin },
  } = windowRef;
  const toReplace = `${protocol}//`;
  return origin.replace(toReplace, "");
}

export default getLocationUrl;
